import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { CommonResponse } from "../models/reponse.model";

export class ResponseHelper {
  static responseDontHaveErrors(response: CommonResponse<any>) {
    // Para operaciones que no devuelven data (como DELETE), verificar solo errores y statusCode
    if (response.statusCode && response.statusCode >= 200 && response.statusCode < 300) {
      return (response.errors === null || response.errors === undefined || response.errors.length === 0);
    }
    
    // Para operaciones que sí devuelven data
    return response.data &&
      !('error' in response.data) &&
      (response.errors === null || response.errors === undefined || response.errors.length === 0);
  }

  static generateCommonResponse(response: HttpResponse<any>) {
    let commonResponse = new CommonResponse();

    commonResponse.data = response.body?.data || undefined;
    commonResponse.message = response.body.message;
    commonResponse.errors = response.body.errors || undefined;
    commonResponse.statusCode = response.status;

    return commonResponse;
  }

  static generateCommonResponseFromHttpErrorResponse(response: HttpErrorResponse) {
    let commonResponse = new CommonResponse();

    commonResponse.message = response.error.message;
    commonResponse.errors = response.error.errors || undefined;
    commonResponse.statusCode = response.status;

    return commonResponse;
  }
}
